import axios from 'axios';
import { createStandaloneToast } from '@chakra-ui/react';

// P1-002: Використовуємо змінну середовища замість захардкодженого localhost
// P3-001: withCredentials дозволяє браузеру автоматично відправляти httpOnly cookie
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 15000,
  withCredentials: true,
});

// Standalone toast instance for use outside React components
const { toast } = createStandaloneToast();

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const errorPayload = error?.response?.data?.error || {};

    if (status >= 500) {
      const errorId = errorPayload.errorId;

      toast({
        title: 'Внутрішня помилка сервера',
        description: errorId
          ? `Сталася неочікувана помилка. Повідомте адміністратору код: ${errorId}.`
          : 'Сталася неочікувана помилка. Спробуйте ще раз або зверніться до адміністратора.',
        status: 'error',
        duration: 8000,
        isClosable: true,
      });
    }

    return Promise.reject(error);
  }
);

export default api;

